/* -disable array-callback-return */
/* -disable consistent-return */
/* -disable react/no-array-index-key */
import React, { Component } from 'react';
import { connect } from 'react-redux';

import { GoogleMap, withScriptjs, withGoogleMap } from 'react-google-maps';

import MarkerClusterer from 'react-google-maps/lib/components/addons/MarkerClusterer';

import GeneralMarker from './GeneralMarker';

import './styles.css';

class OperationalDashboardVehiclesMap extends Component {
  state = {};

  render() {
    const { data } = this.props;

    return (
      <div>
        <GoogleMap
          defaultZoom={5}
          defaultCenter={{ lat: -13.4282273, lng: -53.8905681 }}
          onZoomChanged={this._hideMarkerTooltip}
          defaultOptions={{
            fullscreenControl: false,
            mapTypeControl: false,
            streetViewControl: false,
            styles: [
              {
                elementType: 'geometry',
                stylers: [
                  {
                    color: '#212121',
                  },
                ],
              },
              {
                elementType: 'labels.icon',
                stylers: [
                  {
                    visibility: 'off',
                  },
                ],
              },
              {
                elementType: 'labels.text.fill',
                stylers: [
                  {
                    color: '#757575',
                  },
                ],
              },
              {
                elementType: 'labels.text.stroke',
                stylers: [
                  {
                    color: '#212121',
                  },
                ],
              },
              {
                featureType: 'administrative',
                elementType: 'geometry',
                stylers: [
                  {
                    color: '#757575',
                  },
                ],
              },
              {
                featureType: 'administrative.country',
                elementType: 'labels.text.fill',
                stylers: [
                  {
                    color: '#9e9e9e',
                  },
                ],
              },
              {
                featureType: 'administrative.land_parcel',
                stylers: [
                  {
                    visibility: 'off',
                  },
                ],
              },
              {
                featureType: 'administrative.locality',
                elementType: 'labels.text.fill',
                stylers: [
                  {
                    color: '#bdbdbd',
                  },
                ],
              },
              {
                featureType: 'poi',
                elementType: 'labels.text.fill',
                stylers: [
                  {
                    color: '#757575',
                  },
                ],
              },
              {
                featureType: 'poi.park',
                elementType: 'geometry',
                stylers: [
                  {
                    color: '#181818',
                  },
                ],
              },
              {
                featureType: 'poi.park',
                elementType: 'labels.text.fill',
                stylers: [
                  {
                    color: '#616161',
                  },
                ],
              },
              {
                featureType: 'poi.park',
                elementType: 'labels.text.stroke',
                stylers: [
                  {
                    color: '#1b1b1b',
                  },
                ],
              },
              {
                featureType: 'road',
                elementType: 'geometry.fill',
                stylers: [
                  {
                    color: '#2c2c2c',
                  },
                ],
              },
              {
                featureType: 'road',
                elementType: 'labels.text.fill',
                stylers: [
                  {
                    color: '#8a8a8a',
                  },
                ],
              },
              {
                featureType: 'road.arterial',
                elementType: 'geometry',
                stylers: [
                  {
                    color: '#373737',
                  },
                ],
              },
              {
                featureType: 'road.highway',
                elementType: 'geometry',
                stylers: [
                  {
                    color: '#3c3c3c',
                  },
                ],
              },
              {
                featureType: 'road.highway.controlled_access',
                elementType: 'geometry',
                stylers: [
                  {
                    color: '#4e4e4e',
                  },
                ],
              },
              {
                featureType: 'road.local',
                elementType: 'labels.text.fill',
                stylers: [
                  {
                    color: '#616161',
                  },
                ],
              },
              {
                featureType: 'transit',
                elementType: 'labels.text.fill',
                stylers: [
                  {
                    color: '#757575',
                  },
                ],
              },
              {
                featureType: 'water',
                elementType: 'geometry',
                stylers: [
                  {
                    color: '#000000',
                  },
                ],
              },
              {
                featureType: 'water',
                elementType: 'labels.text.fill',
                stylers: [
                  {
                    color: '#3d3d3d',
                  },
                ],
              },
            ],
          }}
        >
          {data && (
            <MarkerClusterer
              clusterClass="OperationalDashboardVehiclesMap__cluster"
              averageCenter
              enableRetinaIcons
              gridSize={30}
              minimumClusterSize={3}
            >
              {data.vehiclesInfo &&
                data.vehiclesInfo.map((vehicle, index) => {
                  if (vehicle.latitude && vehicle.longitude) {
                    return (
                      <GeneralMarker
                        key={index}
                        position={{
                          lat: vehicle.latitude,
                          lng: vehicle.longitude,
                        }}
                      />
                    );
                  }
                })}
            </MarkerClusterer>
          )}
        </GoogleMap>
      </div>
    );
  }
}

const mapStateToProps = () => ({});

export default connect(mapStateToProps)(
  withScriptjs(withGoogleMap(OperationalDashboardVehiclesMap)),
);
